module.exports = __webpack_public_path__ + "static/img/pay-wx.bbff055d.jpg";